<!--    CSV-Download-Modal integrated Datepicker, since this one needs to have some differences -->
<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { onMount } from "svelte";

    export let start_date;
    export let end_date;

    onMount(() => {
        start_date = moment().subtract(2, "weeks"); // Two weeks ago
        end_date = moment();
        daterange_picker(start_date, end_date);
    });

    function daterange_picker(start, end) {
        moment.locale("de");
        var start = start;
        var end = end;

        function cb(selectedStartDate, selectedEndDate) {
            window
                .jQuery("#kai-datepicker_csv span")
                .html(
                    selectedStartDate.format("DD.MM.YY") +
                        " - " +
                        selectedEndDate.format("DD.MM.YY"),
                );
            // Update the global selected_daterange variable
            start_date = selectedStartDate;
            end_date = selectedEndDate;
        }

        // Initialize the date range picker with options
        window.jQuery("#kai-datepicker_csv").daterangepicker(
            {
                startDate: start,
                endDate: end,
                showDropdowns: true,
                timePicker: true,
                timePicker24Hour: true,
                linkedCalendars: false,
                minDate: "01.01.2000",
                maxDate: "31.12.2035",
                ranges: {
                    "1 Tag": [moment().subtract(1, "days"), moment()],
                    "1 Woche": [moment().subtract(1, "weeks"), moment()],
                    "1 Monat": [moment().subtract(1, "months"), moment()],
                    "3 Monat": [moment().subtract(3, "months"), moment()],
                    "6 Monate": [moment().subtract(6, "months"), moment()],
                    "1 Jahr": [moment().subtract(1, "years"), moment()],
                    "3 Jahre": [moment().subtract(3, "years"), moment()],
                    "5 Jahre": [moment().subtract(5, "years"), moment()],
                },
                locale: {
                    separator: " - ",
                    applyLabel: "Übernehmen",
                    cancelLabel: "Abbrechen",
                    fromLabel: "Von",
                    toLabel: "Bis",
                    customRangeLabel: "Auswahl",
                    weekLabel: "W",
                    daysOfWeek: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                    monthNames: [
                        "Januar",
                        "Februar",
                        "März",
                        "April",
                        "Mai",
                        "Juni",
                        "Juli",
                        "August",
                        "September",
                        "Oktober",
                        "November",
                        "Dezember",
                    ],
                    firstDay: 1,
                },
                alwaysShowCalendars: true,
                drops: "down",
                opens: "center", // Set the dropdown to open on the right side
                autoUpdateInput: false, // Prevent automatic input update
            },
            cb,
        );

        cb(start, end);
    }
</script>

<div
    class="dropdown btn-distance"
    id="daterange_select"
    style="margin-right:0;width:100%;"
>
    <div
        id="kai-datepicker_csv"
        class="kai-datepicker btn btn-primary dropdown-toggle"
    >
        <i class="fa fa-calendar"></i>&nbsp;&nbsp;<span class="date-picker-date"
        ></span>&nbsp;
    </div>
</div>
